import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function LoadingSpinner({
  className,
  size = 'md',
  label = 'Loading...',
}: LoadingSpinnerProps) {
  return (
    <div
      className={cn('flex items-center justify-center gap-2', className)}
      role="status"
      aria-label={label}
    >
      <Loader2 className={cn('animate-spin text-primary', sizeClasses[size])} />
      <span className="sr-only">{label}</span>
    </div>
  );
}

interface FullPageSpinnerProps {
  label?: string;
}

export function FullPageSpinner({ label = 'Loading...' }: FullPageSpinnerProps) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingSpinner size="lg" label={label} />
    </div>
  );
}
